// extracted by mini-css-extract-plugin
export default {"container":"GD-z","dimension":"HD-z","dimensionLabels":"ID-z"};